import { PathVisualizationColumnRenderer } from '../../../path-visualization/PathVisualizationColumnRenderer';

export function getPathAnalysisColumns() {
    return [
        {
            minWidth: 100,
            flex: 1,
            sortable: false,
            tooltip: false,
            resizable: false,
            renderer: PathVisualizationColumnRenderer,
        },
    ];
}
